import styled from 'styled-components';
import { css } from 'styled-components';

export const ThermalComfortContainer = styled.div`
	top: 23px;
	left: 55px;
	width: 609px;
	height: 544px;
`;

export const ThermalComfortImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
`;

export const CustomText = styled.p`
	${({ theme }) => css`
		${{ ...theme.fonts.body.lg }}
	`}
	text-align: center;
`;
